export { default } from './fixed-bottom.component';
